const worldCup = {
    state: {
        countryList: [],
        countryLoaded: false,
    },
    mutations: {
        setWorldCupCountryList: (state, list) => {
            state.countryList = Array.isArray(list) ? list : []
            state.countryLoaded = true
        },
        clearWorldCupCountryList: (state) => {
            state.countryList = []
            state.countryLoaded = false
        },
    },
    actions: {
        setWorldCupCountryList: ({ commit }, list) => {
            commit('setWorldCupCountryList', list)
        },
        clearWorldCupCountryList: ({ commit }) => {
            commit('clearWorldCupCountryList')
        },
    },
    getters: {
        getWorldCupCountryList: (state) => {
            return state.countryList || []
        },
        isWorldCupCountryLoaded: (state) => {
            return !!state.countryLoaded
        },
    },
}

export default worldCup



// WEBPACK FOOTER //
// ./src/store/worldCup/index.js